/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FaxWebhookConfigResponseDto
 */
export interface FaxWebhookConfigResponseDto {
    /**
     * 
     * @type {string}
     * @memberof FaxWebhookConfigResponseDto
     */
    sinchServiceId: string;
    /**
     * 
     * @type {string}
     * @memberof FaxWebhookConfigResponseDto
     */
    incomingWebhookUrl: string;
    /**
     * 
     * @type {string}
     * @memberof FaxWebhookConfigResponseDto
     */
    webhookContentType: string;
    /**
     * 
     * @type {string}
     * @memberof FaxWebhookConfigResponseDto
     */
    faxNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof FaxWebhookConfigResponseDto
     */
    faxNumberAssigned: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FaxWebhookConfigResponseDto
     */
    hipaaStorageDisabled: boolean;
}

/**
 * Check if a given object implements the FaxWebhookConfigResponseDto interface.
 */
export function instanceOfFaxWebhookConfigResponseDto(value: object): value is FaxWebhookConfigResponseDto {
    if (!('sinchServiceId' in value) || value['sinchServiceId'] === undefined) return false;
    if (!('incomingWebhookUrl' in value) || value['incomingWebhookUrl'] === undefined) return false;
    if (!('webhookContentType' in value) || value['webhookContentType'] === undefined) return false;
    if (!('faxNumber' in value) || value['faxNumber'] === undefined) return false;
    if (!('faxNumberAssigned' in value) || value['faxNumberAssigned'] === undefined) return false;
    if (!('hipaaStorageDisabled' in value) || value['hipaaStorageDisabled'] === undefined) return false;
    return true;
}

export function FaxWebhookConfigResponseDtoFromJSON(json: any): FaxWebhookConfigResponseDto {
    return FaxWebhookConfigResponseDtoFromJSONTyped(json, false);
}

export function FaxWebhookConfigResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxWebhookConfigResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sinchServiceId': json['sinchServiceId'],
        'incomingWebhookUrl': json['incomingWebhookUrl'],
        'webhookContentType': json['webhookContentType'],
        'faxNumber': json['faxNumber'],
        'faxNumberAssigned': json['faxNumberAssigned'],
        'hipaaStorageDisabled': json['hipaaStorageDisabled'],
    };
}

export function FaxWebhookConfigResponseDtoToJSON(json: any): FaxWebhookConfigResponseDto {
    return FaxWebhookConfigResponseDtoToJSONTyped(json, false);
}

export function FaxWebhookConfigResponseDtoToJSONTyped(value?: FaxWebhookConfigResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sinchServiceId': value['sinchServiceId'],
        'incomingWebhookUrl': value['incomingWebhookUrl'],
        'webhookContentType': value['webhookContentType'],
        'faxNumber': value['faxNumber'],
        'faxNumberAssigned': value['faxNumberAssigned'],
        'hipaaStorageDisabled': value['hipaaStorageDisabled'],
    };
}

